import { Store } from 'libx'
import { UserCoupon } from '../domain/Coupon'
import { runInAction, action } from 'mobx'
import autobind from 'autobind-decorator'

@autobind
export default class CouponStore extends Store {
  constructor () {
    super(...arguments)
    this.coupons = this.collection({
      model: UserCoupon
    })
  }

  get api () {
    return this.rootStore.api
  }

  async getCoupons () {
    await this.rootStore.retryOnNetworkFailure(() => this.api.coupons.getUserCoupons())
      .retryMessage('Network issue while loading coupons, retrying...')
      .networkIssueMessage('Could not reach the coupon system')
      .then(action(this.coupons.set))
    return this.coupons
  }

  async addCoupon (code) {
    try {
      const userCoupon = await this.rootStore.retryOnNetworkFailure(() => this.api.coupons.addCouponToUser(code))
        .retryMessage('Network issue while applying coupon, retrying...')
        .networkIssueMessage('Could not reach the coupon system')
      if (userCoupon === false) {
        return { success: false }
      }
      runInAction(() => {
        this.coupons.set(userCoupon)
      })
      return {
        success: true
      }
    } catch (err) {
      const body = err.response ? err.response.data : { message: err.message }
      this.rootStore.flashMessageStore.create(body.message).failed().autoDismiss()
      return {
        success: false,
        message: body.message,
        errors: body.errors
      }
    }
  }

  calculateNewPrice (currentPrice) {
    return this.rootStore.retryOnNetworkFailure(() => this.api.coupons.calculateNewPrice(currentPrice))
      .retryMessage('Network issue while calculating discount, retrying...')
      .networkIssueMessage('Could not reach the coupon system.')
  }
}



// WEBPACK FOOTER //
// ./src/client/store/CouponStore.js